var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequiredChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFC216"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8892 17.9596L8.66676 13.533L6.42871 15.8791L11.77 21.4787C12.0671 21.7894 12.4695 21.9643 12.8892 21.9643C13.3085 21.9643 13.711 21.7895 14.0081 21.4787L23.5716 11.4529L21.3335 9.10712L12.8892 17.9596Z",
    fill: "#24272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequiredChecked);
export default __webpack_public_path__ + "static/media/required-checked.bf1937efd2227ae5642420e47df7b48c.svg";
export { ForwardRef as ReactComponent };